/** A rate card's own page gives each tab its own route, `/rate-cards/:id/<tab>` (`recordTabRoutes`). */
export const RATE_CARD_TABS = ['lines', 'accessorial-rates', 'proposals'] as const;
export type RateCardTab = (typeof RATE_CARD_TABS)[number];

export const RATE_CARD_TAB_LABELS: Record<RateCardTab, string> = { lines: 'Lines', 'accessorial-rates': 'Accessorial rates', proposals: 'Proposals' };

export const RATE_CARDS_PATH = '/rate-cards';

/** The /rate-cards page's own views, `/rate-cards/<tab>`; the bare path redirects to the first. */
export const RATE_CARDS_TABS = ['cards', 'approvals', 'off-card-report'] as const;
export type RateCardsTab = (typeof RATE_CARDS_TABS)[number];

export const RATE_CARDS_TAB_LABELS: Record<RateCardsTab, string> = { cards: 'Rate cards', approvals: 'Approval queue', 'off-card-report': 'Off-card report' };

export function rateCardsTabPath(tab: RateCardsTab): string {
  return `${RATE_CARDS_PATH}/${tab}`;
}

export function rateCardPath(id: string): string {
  return `${RATE_CARDS_PATH}/${id}`;
}

export function rateCardTabPath(id: string, tab: RateCardTab): string {
  return `${rateCardPath(id)}/${tab}`;
}

/** Below the Lines tab, not a tab itself — a spreadsheet round trip for this card's prices (gitaumoses4/chukua#28). */
export function rateCardImportPath(id: string): string {
  return `${rateCardTabPath(id, 'lines')}/import`;
}
